import { STORE_KEYS } from 'configs/fetchApi';
import { callStoreFetch } from './response';
import { header } from './settings';

const EndPoint = {
    GetGameConfig: () => `/v1/config/games`
};

export function getGameConfig() {
    const cli = callStoreFetch(STORE_KEYS.SERVER_GAMES, getGameConfig.name);
    const uri = EndPoint.GetGameConfig();
    let settings = {
        method: 'GET',
        headers: { ...header }
    };

    return cli(uri, settings);
}
